import { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { useViewportStore, useDiagramStore } from '@/stores'
import { IconButton } from '@/components/ui/IconButton'
import { ResetZoomIcon } from '@/components/ui/icons'
import { Tooltip, TOOLBAR_TOOLTIP_DELAY_MS } from '@/components/ui/Tooltip'

export function ZoomControls() {
  const { t } = useTranslation()
  const sc     = useViewportStore((state) => state.sc)
  const zoomIn  = useViewportStore((state) => state.zoomIn)
  const zoomOut = useViewportStore((state) => state.zoomOut)

  // Reset view: fitAll when tables exist, else reset to defaults (legacy btn-zr)
  const handleResetView = useCallback(() => {
    const tables = useDiagramStore.getState().tables
    useViewportStore.getState().resetView(tables)
  }, [])

  return (
    <div data-guide="zoom-controls" className="flex items-center gap-1">
      <Tooltip content={t('toolbar.zoomOut')} delayMs={TOOLBAR_TOOLTIP_DELAY_MS}>
        <IconButton aria-label={t('toolbar.zoomOut')} onClick={zoomOut} icon="−" size="sm" />
      </Tooltip>
      <span
        className="inline-flex h-[30px] min-w-[54px] items-center justify-center rounded-md border px-2 text-[11px]"
        style={{
          borderColor: 'var(--border)',
          background: 'var(--bg-app)',
          color: 'var(--text-muted)',
        }}
      >
        {Math.round(sc * 100)}%
      </span>
      <Tooltip content={t('toolbar.zoomIn')} delayMs={TOOLBAR_TOOLTIP_DELAY_MS}>
        <IconButton aria-label={t('toolbar.zoomIn')} onClick={zoomIn} icon="+" size="sm" />
      </Tooltip>
      <Tooltip content={t('toolbar.zoomReset')} delayMs={TOOLBAR_TOOLTIP_DELAY_MS}>
        <IconButton aria-label={t('toolbar.zoomReset')} onClick={handleResetView} icon={<ResetZoomIcon />} size="sm" />
      </Tooltip>
    </div>
  )
}
